export const C = {
  p50: '#EFF6FF', p100: '#DBEAFE', p200: '#BFDBFE', p400: '#60A5FA',
  p500: '#3B82F6', p600: '#2563EB', p700: '#1D4ED8',
  n50: '#F8FAFC', n100: '#F1F5F9', n200: '#E2E8F0', n300: '#CBD5E1',
  n400: '#94A3B8', n500: '#64748B', n600: '#475569', n700: '#334155', n900: '#0F172A',
  g50: '#ECFDF5', g500: '#10B981', g600: '#059669',
  v50: '#F5F3FF', v500: '#8B5CF6',
  a50: '#FFFBEB', a500: '#F59E0B',
  r50: '#FEF2F2', r100: '#FECACA', r500: '#EF4444',
  w: '#FFFFFF',
};
